import { solidstate } from ":shared/utils/state-manager";
import type { AItemProps } from "./_model";

export const $modals = solidstate.createGlobal<AItemProps[]>([]);
export const actions = {
  pushModal(props: AItemProps) {
    $modals.set((s) => [...s, props]);
  },
};
